import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { RestService } from "../rest.service";
import { Router } from "@angular/router";
import { catchError, retry } from "rxjs/operators";
import moment from 'moment';
import 'moment-timezone';
import { Activity, CalenderDay, CalenderDayEntries, CalenderResponse } from "src/models/CalenderResponse";
// import * as moment from "moment";
// import { max } from "moment";
// import * as moment from 'moment-timezone';
// import { Moment } from 'moment';

@Component({
  selector: "app-schedule-calendar",
  templateUrl: "./schedule-calendar.component.html",
  styleUrls: ["./schedule-calendar.component.css"],
})
export class ScheduleCalendarComponent implements OnInit {
  rows: any = [];

  isLoading: boolean = false;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";
  currentMonday: any = "";
  currentWeekLastDay: any = "";
  firstDay: any = "";

  monGroupId: any = 0;
  monGroupArray: any = [];
  mondaySchedule: any = [];
  monFilterItems: any = [];
  mondayMaintenance: any = [];
  monMtnFilterItems: any = [];
  monMtnGroupId: any = 0;
  monMtnGroupArray: any = [];
  monMtnEndDate: any = [];
  monEndDates:any = [];

  tueGroupId: any = 0;
  tueGroupArray: any = [];
  tuesdaySchedule: any = [];
  tueFilterItems: any = [];
  tuesdayMaintenance: any = [];
  tueMtnFilterItems: any = [];
  tueMtnGroupId: any = 0;
  tueMtnGroupArray: any = [];
  tueMtnEndDate: any = [];
  tueEndDates:any = [];

  wedMaxLength: any = 0;
  wedGroupId: any = 0;
  wedGroupArray: any = [];
  wedUniqId: any = [];
  wedSeekIndex: any = [];
  wednesdaySchedule: any = [];
  wedFilterItems: any = [];
  wednesdayMaintenance: any = [];
  wedMtnFilterItems: any = [];
  wedMtnGroupId: any = 0;
  wedMtnGroupArray: any = [];
  wedMtnEndDate: any = [];
  wedEndDates:any = [];

  thuGroupId: any = 0;
  thuGroupArray: any = [];
  thursdaySchedule: any = [];
  thuFilterItems: any = [];
  thursdayMaintenance: any = [];
  thuMtnFilterItems: any = [];
  thuMtnGroupId: any = 0;
  thuMtnGroupArray: any = [];
  thuMtnEndDate: any = [];
  thuEndDates:any = [];


  friGroupId: any = 0;
  friGroupArray: any = [];
  fridaySchedule: any = [];
  friFilterItems: any = [];
  fridayMaintenance: any = [];
  friMtnFilterItems: any = [];
  friMtnGroupId: any = 0;
  friMtnGroupArray: any = [];
  friMtnEndDate: any = [];
  friEndDates:any = [];


  satGroupId: any = 0;
  satGroupArray: any = [];
  saturdaySchedule: any = [];
  satFilterItems: any = [];
  saturdayMaintenance: any = [];
  satMtnFilterItems: any = [];
  satMtnGroupId: any = 0;
  satMtnGroupArray: any = [];
  satMtnEndDate: any = [];
  satEndDates:any = [];


  sunGroupId: any = 0;
  sunGroupArray: any = [];
  sundaySchedule: any = [];
  sunFilterItems: any = [];
  sundayMaintenance: any = [];
  sunMtnFilterItems: any = [];
  sunMtnGroupId: any = 0;
  sunMtnGroupArray: any = [];
  sunMtnEndDate: any = [];
  sunEndDates:any = [];


  mday: any = [];
  mdayConfilct: any = [];
  mmday: any = [];

  tday: any = [];
  tdayConfilct: any = [];
  tmtnday: any = [];

  wday: any = [];
  wdayConfilct: any = [];
  wmtnday: any = [];

  thday: any = [];
  thdayConfilct: any = [];
  thmtnday: any = [];

  frday: any = [];
  frdayConfilct: any = [];
  frmtnday: any = [];

  saday: any = [];
  sadayConfilct: any = [];
  samtnday: any = [];

  suday: any = [];
  sudayConfilct: any = [];
  sumtnday: any = [];

  envList: any = [];
  environment: any = "";
  environmentName: any = "";
  masterEnvId: any = "";

  displayDates: any = [];
  finalEndate: any = [];

  isInfoModelShown: boolean = false;
  infoMessage: string = "";
  isShownCalendar: boolean = false;
  timezoneInfo: boolean = false;
  selectedTimeZone: string = "";
  localTimeZone: string = "";
  hidePrev: boolean = true;
  mainArr  = [];
  baseStartTime:any;
  baseEndTime:any;

  fromNow: any;
  a: moment.Moment;
  aFormat: any;
  aUtcFormat: any;
  aDateFormat: any;
  aTimeFormat: any;
  aSpecialFormat: any;
  date: moment.Moment;
  displayTz:any;
  private timeFormat = 'LTS';
  private format = 'LLL Z z';
  private dateFormat = 'L';

  constructor(private _restService: RestService, private router: Router) { }

  @Output() timelineDate = new EventEmitter<any>();

  ngOnInit() {
    this.selectedTimeZone = localStorage.getItem("selectedTimeZone");
    this.localTimeZone = localStorage.getItem("localTimeZone");
    this.isLoading = true;
    this.checkTimezone();
    //let timezone: any = parseInt(localStorage.getItem("timezone"));
    let timezone: any = 330;
    this.hidePrev = true;
    var t = new Date();
    var day = t.getDay() || 7;
    if (day !== 1) t.setHours(-24 * (day - 1));
    this.currentMonday = t;
    this.firstDay = t;

    var q = new Date(this.currentMonday);
    var d = q.getDate();
    var m = q.getMonth() + 1;
    var y = q.getFullYear();
    var mstart = y + "-" + m + "-" + d;

    this.displayDates = [];
    var currentWeekStartDate = new Date(t);
    this.displayDates.push(new Date(currentWeekStartDate).getDate());
    for (let i = 1; i < 7; i++) {
      this.displayDates.push(
        new Date(
          currentWeekStartDate.setDate(currentWeekStartDate.getDate() + 2 - 1)
        ).getDate()
      );
    }

    var today = new Date(t);

    var next = new Date(today);
    next.setDate(next.getDate() + 7 - 1);
    this.currentWeekLastDay = next.toString();

    var p = new Date(this.currentWeekLastDay);
    var d = p.getDate();
    var m = p.getMonth() + 1;
    var y = p.getFullYear();
    var mend = y + "-" + m + "-" + d;

    this.rows = Array(24)
      .fill(0)
      .map((x, i) => i);

    var dt: any;
    var utcoffset: any;
    let start: any;
    var end: any;

    let timezoneOffset = localStorage.getItem("timezoneOffset");
    let timezoneName = localStorage.getItem("timezoneName");

    this._restService
      .environmentList()
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => {
          this.envList = f.EnvList;
          this.environment = this.envList.length > 0 ? this.envList[0].id : "";
          this.environmentName = this.envList.length > 0 ? this.envList[0].Environment_Name : "";
          this.envList.filter((m: any) => {
            parseInt(m.id) === parseInt(this.environment)
              ? (this.masterEnvId = m.MasterEnvId)
              : ""
          });
          console.log('Calling get week schedule');
          this.getWeekDaysSchedule(mstart, mend);
      });
  }

  gotoTimeline(dt: any) {
    var t = new Date().getTime();
    var s = new Date(dt).getTime();

    if (s >= t) {
      this.timelineDate.emit(dt);
    } else {
      this.isInfoModelShown = true;
    }
  }

  cancelInfoMessage() {
    this.isInfoModelShown = false;
  }

  callScheduleCal() {
    this.ngOnInit();
  }

  displayCalendar() {
    this.isShownCalendar = true;
  }

  applyCalendar() {
    var dt = localStorage.getItem("startRange");
    var selectedDate = dt.split("/").reverse().join("-");

    var t = new Date(selectedDate);
    var day = t.getDay() || 7;
    if (day !== 1) t.setHours(-24 * (day - 1));
    this.currentMonday = t;

    var q = new Date(this.currentMonday);
    var d = q.getDate();
    var m = q.getMonth() + 1;
    var y = q.getFullYear();
    var mstart = y + "-" + m + "-" + d;

    var today = new Date(t);
    var next = new Date(today);
    next.setDate(next.getDate() + 7 - 1);
    this.currentWeekLastDay = next.toString();

    var p = new Date(this.currentWeekLastDay);
    var d = p.getDate();
    var m = p.getMonth() + 1;
    var y = p.getFullYear();
    var mend = y + "-" + m + "-" + d;

    var f = new Date(this.firstDay);
    var tday = f.getFullYear() + "-" + (f.getMonth() + 1) + "-" + f.getDate();

    if (mstart === tday) {
      this.hidePrev = true;
    } else {
      this.hidePrev = false;
    }

    this.displayDates = [];
    var currentWeekStartDate = new Date(t);
    this.displayDates.push(new Date(currentWeekStartDate).getDate());
    for (let i = 1; i < 7; i++) {
      this.displayDates.push(
        new Date(
          currentWeekStartDate.setDate(currentWeekStartDate.getDate() + 2 - 1)
        ).getDate()
      );
    }

    this.rows = Array(24)
      .fill(0)
      .map((x, i) => i);

    this.callCalendarView(mstart, mend);
    this.isShownCalendar = false;
  }

  closeCalendar() {
    this.isShownCalendar = false;
  }

  environmentEvent(e: any) {
    console.log("1");
    
    this.isLoading = true;
    let v = e.target.value;
    this.environment = v;

    var t = new Date();
    var day = t.getDay() || 7;
    if (day !== 1) t.setHours(-24 * (day - 1));
    this.currentMonday = t;
    this.firstDay = t;

    this.envList.filter((m: any) =>
      parseInt(m.id) === parseInt(this.environment)
        ? (this.masterEnvId = m.MasterEnvId)
        : ""
    );

    var q = new Date(this.currentMonday);
    var d = q.getDate();
    var m = q.getMonth() + 1;
    var y = q.getFullYear();
    var mstart = y + "-" + m + "-" + d;

    var today = new Date(t);
    var next = new Date(today);
    next.setDate(next.getDate() + 7 - 1);
    this.currentWeekLastDay = next.toString();

    var p = new Date(this.currentWeekLastDay);
    var d = p.getDate();
    var m = p.getMonth() + 1;
    var y = p.getFullYear();
    var mend = y + "-" + m + "-" + d;

    this.displayDates = [];
    var currentWeekStartDate = new Date(t);
    this.displayDates.push(new Date(currentWeekStartDate).getDate());
    for (let i = 1; i < 7; i++) {
      this.displayDates.push(
        new Date(
          currentWeekStartDate.setDate(currentWeekStartDate.getDate() + 2 - 1)
        ).getDate()
      );
    }

    this.rows = Array(24)
      .fill(0)
      .map((x, i) => i);

    this.callCalendarView(mstart, mend);
  }

  callCalendarView(mstart: any, mend: any) {
    let timezoneOffset = localStorage.getItem("timezoneOffset");
    let timezoneName = localStorage.getItem("timezoneName");
    this.getWeekDaysSchedule(mstart, mend);
  }

  checkTimezone() {
    var dt = new Date();
    var offset = dt.getTimezoneOffset();
    var timezone: any = parseInt(localStorage.getItem("timezone"));

    if (Math.abs(offset) !== Math.abs(timezone)) {
      this.timezoneInfo = true;
    } else {
      this.timezoneInfo = false;
    }
  }

  prev() {
    console.log('3');
    this.isLoading = true;
    this.isShownCalendar = false;
    var s_elems = document.querySelectorAll(".bh-sh-group");
    s_elems.forEach(function (element) {
      element.parentNode.removeChild(element);
    });

    var m_elems = document.querySelectorAll(".bh-mnt-group");
    m_elems.forEach(function (element) {
      element.parentNode.removeChild(element);
    });

    var today = new Date(this.currentMonday);
    var firstMonday = new Date(today);
    firstMonday.setDate(firstMonday.getDate() - 7);
    this.currentMonday = firstMonday.toString();
    this.firstDay = this.firstDay.toString();

    var q = new Date(this.currentMonday);
    var d = q.getDate();
    var m = q.getMonth() + 1;
    var y = q.getFullYear();
    var mstart = y + "-" + m + "-" + d;

    var t = new Date(this.currentMonday);
    var lastDay = new Date(t);
    lastDay.setDate(lastDay.getDate() + 6);
    this.currentWeekLastDay = lastDay.toString();

    var p = new Date(this.currentWeekLastDay);
    var d = p.getDate();
    var m = p.getMonth() + 1;
    var y = p.getFullYear();
    var mend = y + "-" + m + "-" + d;

    var f = new Date(this.firstDay);
    var tday = f.getFullYear() + "-" + (f.getMonth() + 1) + "-" + f.getDate();

    if (mstart === tday) {
      this.hidePrev = true;
    }

    let timezoneOffset = localStorage.getItem("timezoneOffset");
    let timezoneName = localStorage.getItem("timezoneName");

    this.displayDates = [];
    var currentWeekStartDate = new Date(t);
    this.displayDates.push(new Date(currentWeekStartDate).getDate());
    for (let i = 1; i < 7; i++) {
      this.displayDates.push(
        new Date(
          currentWeekStartDate.setDate(currentWeekStartDate.getDate() + 2 - 1)
        ).getDate()
      );
    }
   
    this.getWeekDaysSchedule(mstart, mend);
  }

  nxt() {
    this.isLoading = true;
    this.isShownCalendar = false;
    this.hidePrev = false;
    var s_elems = document.querySelectorAll(".bh-sh-group");
    s_elems.forEach(function (element) {
      element.parentNode.removeChild(element).removeAttribute("style");
      element.removeAttribute("style");
    });

    var m_elems = document.querySelectorAll(".bh-mnt-group");
    m_elems.forEach(function (element) {
      element.parentNode.removeChild(element).removeAttribute("style");
      element.removeAttribute("style");
    });

    var today = new Date(this.currentMonday);
    var firstMonday = new Date(today);
    firstMonday.setDate(firstMonday.getDate() + 7);
    this.currentMonday = firstMonday.toString();

    var q = new Date(this.currentMonday);
    var d = q.getDate();
    var m = q.getMonth() + 1;
    var y = q.getFullYear();
    var mstart = y + "-" + m + "-" + d;

    var t = new Date(this.currentMonday);
    var lastDay = new Date(t);
    lastDay.setDate(lastDay.getDate() + 7 - 1);
    this.currentWeekLastDay = lastDay.toString();

    var p = new Date(this.currentWeekLastDay);
    var d = p.getDate();
    var m = p.getMonth() + 1;
    var y = p.getFullYear();
    var mend = y + "-" + m + "-" + d;

    this.displayDates = [];
    var currentWeekStartDate = new Date(t);
    this.displayDates.push(new Date(currentWeekStartDate).getDate());
    for (let i = 1; i < 7; i++) {
      this.displayDates.push(
        new Date(
          currentWeekStartDate.setDate(currentWeekStartDate.getDate() + 2 - 1)
        ).getDate()
      );
    }

    this.getWeekDaysSchedule(mstart, mend);
  }


  getWeekDaysSchedule(mstart: string, mend: string){
    this.mondaySchedule = [];
    this.mondayMaintenance = [];
    this.tuesdaySchedule = [];
    this.tuesdayMaintenance = [];
    this.wednesdaySchedule = [];
    this.wednesdayMaintenance = [];
    this.thursdaySchedule = [];
    this.thursdayMaintenance = [];
    this.fridaySchedule = [];
    this.fridayMaintenance = [];
    this.saturdaySchedule = [];
    this.saturdayMaintenance = [];
    this.sundaySchedule = [];
    this.sundayMaintenance = [];

      // timezoneOffset,
      // timezoneName
    this._restService
      .getCalenderView(
        this.environment,
        mstart.toString(),
        mend.toString(),
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: CalenderResponse) => {
          this.isLoading = false;
          const calendarRes = f.CalenderRes;
          var timeZoneFromDB:any = localStorage.getItem('timezoneName');
          calendarRes.AllMaintenanceArr.forEach(m => m.conflictCount = 0);

          calendarRes.AllScheduleArr.forEach(schedule => {
            schedule.conflictCount = 0;

            calendarRes.AllMaintenanceArr.forEach(maintenance => {
              if (this.hasConflict(schedule.StartDate,schedule.EndDate, maintenance.StartDate, maintenance.EndDate) 
              && ( !maintenance.systemId || (schedule.AccessList && schedule.AccessList.indexOf(maintenance.systemId) >= 0) ) ){
                schedule.conflictCount++;
              }
            });
          });

          
          this.mondaySchedule= this.convertToCalendarDay(calendarRes.AllScheduleArr, mstart, 0);
          this.tuesdaySchedule = this.convertToCalendarDay(calendarRes.AllScheduleArr, mstart, 1);
          this.wednesdaySchedule = this.convertToCalendarDay(calendarRes.AllScheduleArr, mstart, 2);
          this.thursdaySchedule = this.convertToCalendarDay(calendarRes.AllScheduleArr, mstart, 3);
          this.fridaySchedule = this.convertToCalendarDay(calendarRes.AllScheduleArr, mstart, 4);
          this.saturdaySchedule = this.convertToCalendarDay(calendarRes.AllScheduleArr, mstart, 5);
          this.sundaySchedule = this.convertToCalendarDay(calendarRes.AllScheduleArr, mstart, 6);

          this.mondayMaintenance = this.convertToCalendarDay(calendarRes.AllMaintenanceArr, mstart, 0);
          this.tuesdayMaintenance = this.convertToCalendarDay(calendarRes.AllMaintenanceArr, mstart, 1);
          this.wednesdayMaintenance = this.convertToCalendarDay(calendarRes.AllMaintenanceArr, mstart, 2);
          this.thursdayMaintenance = this.convertToCalendarDay(calendarRes.AllMaintenanceArr, mstart, 3);
          this.fridayMaintenance = this.convertToCalendarDay(calendarRes.AllMaintenanceArr, mstart, 4);
          this.saturdayMaintenance = this.convertToCalendarDay(calendarRes.AllMaintenanceArr, mstart, 5);
          this.sundayMaintenance = this.convertToCalendarDay(calendarRes.AllMaintenanceArr, mstart, 6);
 
          this.monFilterItems = this.generateFilterItems(this.mondaySchedule);
          this.tueFilterItems = this.generateFilterItems(this.tuesdaySchedule);
          this.wedFilterItems = this.generateFilterItems(this.wednesdaySchedule);
          this.thuFilterItems = this.generateFilterItems(this.thursdaySchedule);
          this.friFilterItems = this.generateFilterItems(this.fridaySchedule);
          this.satFilterItems = this.generateFilterItems(this.saturdaySchedule);
          this.sunFilterItems = this.generateFilterItems(this.sundaySchedule);

          this.monMtnFilterItems = this.generateFilterItems(this.mondayMaintenance);
          this.tueMtnFilterItems = this.generateFilterItems(this.tuesdayMaintenance);
          this.wedMtnFilterItems = this.generateFilterItems(this.wednesdayMaintenance);
          this.thuMtnFilterItems = this.generateFilterItems(this.thursdayMaintenance);
          this.friMtnFilterItems = this.generateFilterItems(this.fridayMaintenance);
          this.satMtnFilterItems = this.generateFilterItems(this.saturdayMaintenance);
          this.sunMtnFilterItems = this.generateFilterItems(this.sundayMaintenance);
          

          this.checkIfSplit(this.monFilterItems, this.monMtnFilterItems);
          this.checkIfSplit(this.tueFilterItems, this.tueMtnFilterItems);
          this.checkIfSplit(this.wedFilterItems, this.wedMtnFilterItems);
          this.checkIfSplit(this.thuFilterItems, this.thuMtnFilterItems);
          this.checkIfSplit(this.friFilterItems, this.friMtnFilterItems);
          this.checkIfSplit(this.satFilterItems, this.satMtnFilterItems);
          this.checkIfSplit(this.sunFilterItems, this.sunMtnFilterItems);
        });
  }

  checkIfSplit(one: CalenderDay [], two: CalenderDay []){

    one.forEach(entry1 => {
      
      two.forEach(entry2 => {
        if (this.shouldSplit(entry1.fromTop, entry1.end, entry2.fromTop, entry2.end )){
          entry1.split = true;
          entry2.split = true;
        }
      });
    })
  }

   shouldSplit(start1: number, end1: number, start2: number, end2: number): boolean{
    if (start1 <= start2 && end1 > start2){
      return true;
    } else if (start1 < end2 && end1 >= end2){
      return true;
    }else if (start1 >= start2 && end1 <= end2){
      return true;
    }else if (start1 <= start2 && end1 >= end2){
      return true;
    }

    return false;
  }

  generateFilterItems (entries: CalenderDayEntries []){
    const result : CalenderDay [] = [];

    const arr = [];

    entries.forEach(entry => {
      arr.push({startOrEnd: 1, value: entry});
      arr.push({startOrEnd: -1, value: entry});
    });

    arr.sort((a, b) => {
      const aDate = a.startOrEnd == 1 ? a.value.startDate : a.value.endDate;
      const bDate = b.startOrEnd == 1 ? b.value.startDate : b.value.endDate;
      if (aDate < bDate){
        return -1;
      }else if (aDate > bDate) {
        return 1;
      }

      return a.startOrEnd >= b.startOrEnd ? -1 : 1;
    });

    let currentCount = 0;
    let max = 0;
    let val: CalenderDay;
    let hours, minutes;

    arr.forEach(compositeEntry => {
      const entry: CalenderDayEntries  = compositeEntry.value;

      if (currentCount == 0){
        val = new CalenderDay();
        val.start = true;
        val.conflictCount = 0;
        val.StartDate = entry.startDate.format("YYYY-MM-DD HH:mm:ss");
        val.stime = new Date(entry.startDate.format("YYYY-MM-DD HH:mm:ss"));
        val.split = false;
        max = 0;
        hours = entry.startDate.hours();
        minutes = entry.startDate.minutes();
        val.fromTop = hours * 39 + (minutes / 60) * 39;
      }

      val.conflictCount += entry.conflictCount;
      currentCount += compositeEntry.startOrEnd;
      max = Math.max(max, currentCount);

      if (currentCount == 0){
        val.scount = max;
        val.conflictCount /= 2;
        hours = entry.endDate.hours();
        minutes = entry.endDate.minutes();
        val.end = hours * 39 + (minutes / 60) * 39;
        val.length = val.end - val.fromTop;
        val.etime = new Date(entry.endDate.format("YYYY-MM-DD HH:mm:ss"));
        result.push(val);
      }
    });

    return result;
  }

  convertToCalendarDay(activities: Activity [], mstart: string, addedDays: number ){
    const result : CalenderDayEntries [] = [];
    const timeZoneFromDB:any = localStorage.getItem('timezoneName');
    const startTime = moment(mstart).add(12, 'hours').tz( timeZoneFromDB).startOf('day').add(addedDays, 'days');
    const endTime = moment(mstart).add(12, 'hours').tz(timeZoneFromDB).startOf('day').add(addedDays + 1, 'days').subtract(1, 'minutes');
    let sTime, eTime;
    

    activities.forEach(activity => {
      sTime = moment(activity.StartDate).tz(timeZoneFromDB);

      if (sTime < startTime){
        sTime = startTime;
      }

      eTime = moment(activity.EndDate).tz(timeZoneFromDB);

      if (eTime > endTime){
        eTime = endTime;
      }

      if (eTime > sTime){
        const entry = new CalenderDayEntries();
        entry.startDate = sTime;
        entry.endDate = eTime;
        entry.conflictCount = activity.conflictCount;
        result.push(entry);
      }
    });

    return result;
  }


  hasConflict(startDate1: Date, endDate1: Date, startDate2: Date, endDate2: Date){
    if (startDate1 <= startDate2 && endDate1 > startDate2){
      return true;
    } else if (startDate1 < endDate2 && endDate1 >= endDate2){
      return true;
    }else if (startDate1 >= startDate2 && endDate1 <= endDate2){
      return true;
    }else if (startDate1 <= startDate2 && endDate1 >= endDate2){
      return true;
    }

    return false;
  }

  convertToTimezone(d: Date) {

    var dt = new Date(d);
    // console.log("timezone check---->"+new Date(d).toLocaleTimeString('en-US', {timeZone: 'US/Alaska'}))

    let offset :any = dt.getTimezoneOffset();
    dt.setMinutes(dt.getMinutes() - offset);

    var local: any = parseInt(localStorage.getItem("localOffset"));
    var timezone: any = parseInt(localStorage.getItem("timezone"));

    console.log("timezone", offset, timezone);

    if (Math.abs(offset) !== Math.abs(timezone)) {
      // let tz = (new Date(dt.setMinutes(dt.getMinutes() - timezone)));
      let mz:any = (new Date(dt.setMinutes(dt.getMinutes() - timezone)));
      // mz = mz*60*1000;
      // mz.setMinutes(mz.getMinutes() - mz.getTimezoneOffset())
      
      console.log("trueeeeeeee" +   mz );
      return (
      
        mz.getFullYear().toString().padStart(4, "0") +
        "-" +
        (mz.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        mz.getDate().toString().padStart(2, "0") +
        " " +
        (mz.getHours() + 1).toString().padStart(2, "0") +
        ":" +
        (mz.getMinutes() + 30).toString().padStart(2, "0") +
        ":" +
        mz.getSeconds().toString().padStart(2, "0")
      );
    } else {
      console.log("falseeeeeee");
      return d;
    }
  }

  timezoneConvert(dt){
    const d = new Date(dt);
    var timeZoneFromDB:any = localStorage.getItem('timezoneName');
    let timezone = moment.tz(d, timeZoneFromDB).format("YYYY-MM-DD HH:mm:ss");
    console.log("timezones dates--->" , timezone);
    
    return timezone;
    
  }

}
